import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const SabalUserCreated = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      <EventBy event={event} /> added a new user <strong>{event.data.username}</strong>
      <Box>
        <strong>Permissions: {event.data.permissions}</strong>
      </Box>
    </Box>
  );
};

export default SabalUserCreated;
